import { useState, useEffect, useCallback } from 'react';
import { message } from 'antd';
import { useStateContext } from '../../../../../contexts/ContextProvider';

export const useManagers = () => {
  const { token } = useStateContext();
  const [managers, setManagers] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchManagers = useCallback(async () => {
    if (!token) return;
    
    setLoading(true);
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/users?token=${token}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        }
      });

      if (response.ok) {
        const data = await response.json();
        // Filtrăm doar managerii (role_id = 2) sau includem toți utilizatorii
        setManagers(data || []);
      } else {
        message.error('Eroare la încărcarea managerilor');
      }
    } catch (error) {
      console.error('Eroare la încărcarea managerilor:', error);
      message.error('Eroare de conexiune');
    } finally {
      setLoading(false);
    }
  }, [token]);

  useEffect(() => {
    fetchManagers();
  }, [fetchManagers]);

  return {
    managers,
    loading,
    fetchManagers
  };
}; 